export * from "./things.component"